module.exports = __webpack_public_path__ + "img/entirelogo.6dd2972d.svg";